import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@chakra-ui/react';

import { selectCurrentJobAttachments } from '../../../../redux/modules/jobs';
import JobInfoSection from '../JobInfoPanel/components/JobInfoSection';

import AttachmentGridItem from './AttachmentBlock';
import AttachmentUploadGridItem from './AttachmentUploadGridItem';

const Attachments = () => {
  const attachments = useSelector(selectCurrentJobAttachments);
  const title = attachments?.length > 3 ? 'Project Attachments (max 4)' : 'Project Attachments';

  const attachmentsList = useMemo(() => {
    if (!attachments || typeof attachments !== 'object') {
      return [];
    }

    return attachments;
  }, [attachments]);

  return (
    <JobInfoSection title={title}>
      <Grid gap={3} templateColumns="repeat(2, 1fr)">
        {attachmentsList.map(attachment => (
          <AttachmentGridItem attachment={attachment} />
        ))}
        <AttachmentUploadGridItem />
      </Grid>
    </JobInfoSection>
  );
};

export default Attachments;
